const O = {
  uat: {
    cl: "GTM-NJX6QWJ",
    co: "GTM-PQRB5NV",
    pe: "GTM-T29WRLG",
    mx: "",
    sodimac: {
      cl: "GTM-WGGFJP",
      co: "GTM-PQRB5NV",
      pe: "GTM-5M8VN5",
      mx: ""
    },
    // FIXME: Add values
    tottus: {
      cl: "",
      co: "",
      pe: "",
      mx: ""
    }
  },
  staging: {
    cl: "GTM-NJX6QWJ",
    co: "GTM-PQRB5NV",
    pe: "GTM-T29WRLG",
    mx: "",
    sodimac: {
      cl: "GTM-WGGFJP",
      co: "GTM-PQRB5NV",
      pe: "GTM-5M8VN5",
      mx: ""
    },
    // FIXME: Add values
    tottus: {
      cl: "",
      co: "",
      pe: "",
      mx: ""
    }
  },
  production: {
    cl: "GTM-NJX6QWJ",
    co: "GTM-PQRB5NV",
    pe: "GTM-T29WRLG",
    mx: "",
    sodimac: {
      cl: "GTM-WGGFJP",
      co: "GTM-PQRB5NV",
      pe: "GTM-5M8VN5",
      mx: ""
    },
    // FIXME: Add values
    tottus: {
      cl: "",
      co: "",
      pe: "",
      mx: ""
    }
  }
}, H = (a) => {
  const { environment: e = "production", regionCode: t, store: r } = a;
  switch (r?.toLowerCase()) {
    case "so_com":
      return O[e]?.sodimac?.[t];
    case "to_com":
      return O[e]?.tottus?.[t];
    default:
      return O[e]?.[t];
  }
}, A = {
  default: ".falabella.com",
  so_com: ".sodimac",
  so_retail: ".sodimac",
  to_com: ".tottus",
  fa_america: ".americanino",
  fa_aldo: ".aldo",
  fa_carters: ".carters",
  fa_crabarr: ".crateandbarrel",
  fa_thedrop: ".thedropzone"
}, V = (a) => {
  const { regionCode: e, store: t } = a, r = t?.toLowerCase();
  let o, c = "";
  switch (r) {
    case "so_com":
    case "so_retail":
    case "to_com":
    case "fa_america":
    case "fa_aldo":
    case "fa_carters":
    case "fa_crabarr":
    case "fa_thedrop":
      o = t === "fa_aldo" && e === "pe" ? ".aldoshoes" : A[r], c = e === "cl" ? ".cl" : `.com.${e}`;
      break;
    default:
      o = A.default, c = e === "cl" ? "" : `.${e}`;
  }
  return `${o}${c}`;
}, X = (a) => {
  const e = a.split("*"), t = e?.[3], r = e?.[4];
  return t && r ? { latitude: t, longitude: r } : {};
};
let E;
function P(a, e) {
  const t = a.charCodeAt(e);
  if (isNaN(t))
    throw new RangeError("Index " + e + ' out of range for string "' + a + '"; please open an issue at https://github.com/Trott/slug/issues/new');
  if (t < 55296 || t > 57343)
    return [a.charAt(e), e];
  if (t >= 55296 && t <= 56319) {
    if (a.length <= e + 1)
      return [" ", e];
    const o = a.charCodeAt(e + 1);
    return o < 56320 || o > 57343 ? [" ", e] : [a.charAt(e) + a.charAt(e + 1), e + 1];
  }
  if (e === 0)
    return [" ", e];
  const r = a.charCodeAt(e - 1);
  if (r < 55296 || r > 56319)
    return [" ", e];
  throw new Error('String "' + a + '" reaches code believed to be unreachable; please open an issue at https://github.com/Trott/slug/issues/new');
}
typeof window < "u" ? window.btoa ? E = function(a) {
  return btoa(unescape(encodeURIComponent(a)));
} : E = function(a) {
  const e = unescape(encodeURIComponent(a + ""));
  let t = "";
  for (let r, o, c = 0, s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="; e.charAt(c | 0) || (s = "=", c % 1); t += s.charAt(63 & r >> 8 - c % 1 * 8)) {
    if (o = e.charCodeAt(c += 3 / 4), o > 255)
      throw new Error("'btoa' failed: The string to be encoded contains characters outside of the Latin1 range.");
    r = r << 8 | o;
  }
  return t;
} : E = function(a) {
  return Buffer.from(a).toString("base64");
};
function m(a, e) {
  let t = U(a, e);
  if ((e && e.fallback !== void 0 ? e.fallback : m.defaults.fallback) === !0 && t === "") {
    let o = "";
    for (let c = 0; c < a.length; c++) {
      const s = P(a, c);
      c = s[1], o += s[0];
    }
    t = U(E(o), e);
  }
  return t;
}
const R = {
  // http://www.eki.ee/wgrs/rom1_bg.pdf
  bg: { Й: "Y", й: "y", X: "H", x: "h", Ц: "Ts", ц: "ts", Щ: "Sht", щ: "sht", Ъ: "A", ъ: "a", Ь: "Y", ь: "y" },
  // Need a reference URL for German, although this is pretty well-known.
  de: { Ä: "AE", ä: "ae", Ö: "OE", ö: "oe", Ü: "UE", ü: "ue" },
  // Need a reference URL for Serbian.
  sr: { đ: "dj", Đ: "DJ" },
  // https://assets.publishing.service.gov.uk/government/uploads/system/uploads/attachment_data/file/864314/ROMANIZATION_OF_UKRAINIAN.pdf
  uk: { И: "Y", и: "y", Й: "Y", й: "y", Ц: "Ts", ц: "ts", Х: "Kh", х: "kh", Щ: "Shch", щ: "shch", Г: "H", г: "h" }
};
let N = {};
function U(a, e) {
  if (typeof a != "string")
    throw new Error("slug() requires a string argument, received " + typeof a);
  typeof e == "string" && (e = { replacement: e }), e = e ? Object.assign({}, e) : {}, e.mode = e.mode || m.defaults.mode;
  const t = m.defaults.modes[e.mode], r = ["replacement", "multicharmap", "charmap", "remove", "lower", "trim"];
  for (let n, i = 0, u = r.length; i < u; i++)
    n = r[i], e[n] = n in e ? e[n] : t[n];
  const o = R[e.locale] || N;
  let c = [];
  for (const n in e.multicharmap) {
    if (!Object.prototype.hasOwnProperty.call(e.multicharmap, n))
      continue;
    const i = n.length;
    c.indexOf(i) === -1 && c.push(i);
  }
  c = c.sort(function(n, i) {
    return i - n;
  });
  const s = e.mode === "rfc3986" ? /[^\w\s\-.~]/ : /[^A-Za-z0-9\s]/;
  let l = "";
  for (let n, i = 0, u = a.length; i < u; i++) {
    n = a[i];
    let d = !1;
    for (let f = 0; f < c.length; f++) {
      const _ = c[f], b = a.substr(i, _);
      if (e.multicharmap[b]) {
        i += _ - 1, n = e.multicharmap[b], d = !0;
        break;
      }
    }
    d || (o[n] ? n = o[n] : e.charmap[n] ? n = e.charmap[n].replace(e.replacement, " ") : n.includes(e.replacement) ? n = n.replace(e.replacement, " ") : n = n.replace(s, "")), l += n;
  }
  return e.remove && (l = l.replace(e.remove, "")), e.trim && (l = l.trim()), l = l.replace(/\s+/g, e.replacement), e.lower && (l = l.toLowerCase()), l;
}
const G = {
  // multibyte devanagari characters (hindi, sanskrit, etc.)
  फ़: "Fi",
  ग़: "Ghi",
  ख़: "Khi",
  क़: "Qi",
  ड़: "ugDha",
  ढ़: "ugDhha",
  य़: "Yi",
  ज़: "Za",
  // hebrew
  // Refs: http://www.eki.ee/wgrs/rom1_he.pdf
  // Refs: https://en.wikipedia.org/wiki/Niqqud
  בִי: "i",
  בֵ: "e",
  בֵי: "e",
  בֶ: "e",
  בַ: "a",
  בָ: "a",
  בֹ: "o",
  וֹ: "o",
  בֻ: "u",
  וּ: "u",
  בּ: "b",
  כּ: "k",
  ךּ: "k",
  פּ: "p",
  שׁ: "sh",
  שׂ: "s",
  בְ: "e",
  חֱ: "e",
  חֲ: "a",
  חֳ: "o",
  בִ: "i"
}, D = {
  // latin
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  Æ: "AE",
  Ç: "C",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  Ð: "D",
  Ñ: "N",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ő: "O",
  Ø: "O",
  Ō: "O",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  Ű: "U",
  Ý: "Y",
  Þ: "TH",
  ß: "ss",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  æ: "ae",
  ç: "c",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  ð: "d",
  ñ: "n",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ő: "o",
  ø: "o",
  ō: "o",
  Œ: "OE",
  œ: "oe",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  ű: "u",
  ý: "y",
  þ: "th",
  ÿ: "y",
  "ẞ": "SS",
  // greek
  α: "a",
  β: "b",
  γ: "g",
  δ: "d",
  ε: "e",
  ζ: "z",
  η: "h",
  θ: "th",
  ι: "i",
  κ: "k",
  λ: "l",
  μ: "m",
  ν: "n",
  ξ: "3",
  ο: "o",
  π: "p",
  ρ: "r",
  σ: "s",
  τ: "t",
  υ: "y",
  φ: "f",
  χ: "x",
  ψ: "ps",
  ω: "w",
  ά: "a",
  έ: "e",
  ί: "i",
  ό: "o",
  ύ: "y",
  ή: "h",
  ώ: "w",
  ς: "s",
  ϊ: "i",
  ΰ: "y",
  ϋ: "y",
  ΐ: "i",
  Α: "A",
  Β: "B",
  Γ: "G",
  Δ: "D",
  Ε: "E",
  Ζ: "Z",
  Η: "H",
  Θ: "Th",
  Ι: "I",
  Κ: "K",
  Λ: "L",
  Μ: "M",
  Ν: "N",
  Ξ: "3",
  Ο: "O",
  Π: "P",
  Ρ: "R",
  Σ: "S",
  Τ: "T",
  Υ: "Y",
  Φ: "F",
  Χ: "X",
  Ψ: "PS",
  Ω: "W",
  Ά: "A",
  Έ: "E",
  Ί: "I",
  Ό: "O",
  Ύ: "Y",
  Ή: "H",
  Ώ: "W",
  Ϊ: "I",
  Ϋ: "Y",
  // turkish
  ş: "s",
  Ş: "S",
  ı: "i",
  İ: "I",
  ğ: "g",
  Ğ: "G",
  // russian
  а: "a",
  б: "b",
  в: "v",
  г: "g",
  д: "d",
  е: "e",
  ё: "yo",
  ж: "zh",
  з: "z",
  и: "i",
  й: "j",
  к: "k",
  л: "l",
  м: "m",
  н: "n",
  о: "o",
  п: "p",
  р: "r",
  с: "s",
  т: "t",
  у: "u",
  ф: "f",
  х: "h",
  ц: "c",
  ч: "ch",
  ш: "sh",
  щ: "sh",
  ъ: "u",
  ы: "y",
  ь: "",
  э: "e",
  ю: "yu",
  я: "ya",
  А: "A",
  Б: "B",
  В: "V",
  Г: "G",
  Д: "D",
  Е: "E",
  Ё: "Yo",
  Ж: "Zh",
  З: "Z",
  И: "I",
  Й: "J",
  К: "K",
  Л: "L",
  М: "M",
  Н: "N",
  О: "O",
  П: "P",
  Р: "R",
  С: "S",
  Т: "T",
  У: "U",
  Ф: "F",
  Х: "H",
  Ц: "C",
  Ч: "Ch",
  Ш: "Sh",
  Щ: "Sh",
  Ъ: "U",
  Ы: "Y",
  Ь: "",
  Э: "E",
  Ю: "Yu",
  Я: "Ya",
  // ukranian
  Є: "Ye",
  І: "I",
  Ї: "Yi",
  Ґ: "G",
  є: "ye",
  і: "i",
  ї: "yi",
  ґ: "g",
  // czech
  č: "c",
  ď: "d",
  ě: "e",
  ň: "n",
  ř: "r",
  š: "s",
  ť: "t",
  ů: "u",
  ž: "z",
  Č: "C",
  Ď: "D",
  Ě: "E",
  Ň: "N",
  Ř: "R",
  Š: "S",
  Ť: "T",
  Ů: "U",
  Ž: "Z",
  // slovak
  ľ: "l",
  ĺ: "l",
  ŕ: "r",
  Ľ: "L",
  Ĺ: "L",
  Ŕ: "R",
  // polish
  ą: "a",
  ć: "c",
  ę: "e",
  ł: "l",
  ń: "n",
  ś: "s",
  ź: "z",
  ż: "z",
  Ą: "A",
  Ć: "C",
  Ę: "E",
  Ł: "L",
  Ń: "N",
  Ś: "S",
  Ź: "Z",
  Ż: "Z",
  // latvian
  ā: "a",
  ē: "e",
  ģ: "g",
  ī: "i",
  ķ: "k",
  ļ: "l",
  ņ: "n",
  ū: "u",
  Ā: "A",
  Ē: "E",
  Ģ: "G",
  Ī: "I",
  Ķ: "K",
  Ļ: "L",
  Ņ: "N",
  Ū: "U",
  // arabic
  أ: "a",
  إ: "i",
  ب: "b",
  ت: "t",
  ث: "th",
  ج: "g",
  ح: "h",
  خ: "kh",
  د: "d",
  ذ: "th",
  ر: "r",
  ز: "z",
  س: "s",
  ش: "sh",
  ص: "s",
  ض: "d",
  ط: "t",
  ظ: "th",
  ع: "aa",
  غ: "gh",
  ف: "f",
  ق: "k",
  ك: "k",
  ل: "l",
  م: "m",
  ن: "n",
  ه: "h",
  و: "o",
  ي: "y",
  ء: "aa",
  ة: "a",
  // farsi
  آ: "a",
  ا: "a",
  پ: "p",
  ژ: "zh",
  گ: "g",
  چ: "ch",
  ک: "k",
  ی: "i",
  // lithuanian
  ė: "e",
  į: "i",
  ų: "u",
  Ė: "E",
  Į: "I",
  Ų: "U",
  // romanian
  ț: "t",
  Ț: "T",
  ţ: "t",
  Ţ: "T",
  ș: "s",
  Ș: "S",
  ă: "a",
  Ă: "A",
  // vietnamese
  Ạ: "A",
  Ả: "A",
  Ầ: "A",
  Ấ: "A",
  Ậ: "A",
  Ẩ: "A",
  Ẫ: "A",
  Ằ: "A",
  Ắ: "A",
  Ặ: "A",
  Ẳ: "A",
  Ẵ: "A",
  Ẹ: "E",
  Ẻ: "E",
  Ẽ: "E",
  Ề: "E",
  Ế: "E",
  Ệ: "E",
  Ể: "E",
  Ễ: "E",
  Ị: "I",
  Ỉ: "I",
  Ĩ: "I",
  Ọ: "O",
  Ỏ: "O",
  Ồ: "O",
  Ố: "O",
  Ộ: "O",
  Ổ: "O",
  Ỗ: "O",
  Ơ: "O",
  Ờ: "O",
  Ớ: "O",
  Ợ: "O",
  Ở: "O",
  Ỡ: "O",
  Ụ: "U",
  Ủ: "U",
  Ũ: "U",
  Ư: "U",
  Ừ: "U",
  Ứ: "U",
  Ự: "U",
  Ử: "U",
  Ữ: "U",
  Ỳ: "Y",
  Ỵ: "Y",
  Ỷ: "Y",
  Ỹ: "Y",
  Đ: "D",
  ạ: "a",
  ả: "a",
  ầ: "a",
  ấ: "a",
  ậ: "a",
  ẩ: "a",
  ẫ: "a",
  ằ: "a",
  ắ: "a",
  ặ: "a",
  ẳ: "a",
  ẵ: "a",
  ẹ: "e",
  ẻ: "e",
  ẽ: "e",
  ề: "e",
  ế: "e",
  ệ: "e",
  ể: "e",
  ễ: "e",
  ị: "i",
  ỉ: "i",
  ĩ: "i",
  ọ: "o",
  ỏ: "o",
  ồ: "o",
  ố: "o",
  ộ: "o",
  ổ: "o",
  ỗ: "o",
  ơ: "o",
  ờ: "o",
  ớ: "o",
  ợ: "o",
  ở: "o",
  ỡ: "o",
  ụ: "u",
  ủ: "u",
  ũ: "u",
  ư: "u",
  ừ: "u",
  ứ: "u",
  ự: "u",
  ử: "u",
  ữ: "u",
  ỳ: "y",
  ỵ: "y",
  ỷ: "y",
  ỹ: "y",
  đ: "d",
  // kazakh
  Ә: "AE",
  ә: "ae",
  Ғ: "GH",
  ғ: "gh",
  Қ: "KH",
  қ: "kh",
  Ң: "NG",
  ң: "ng",
  Ү: "UE",
  ү: "ue",
  Ұ: "U",
  ұ: "u",
  Һ: "H",
  һ: "h",
  Ө: "OE",
  ө: "oe",
  // serbian
  ђ: "dj",
  ј: "j",
  љ: "lj",
  њ: "nj",
  ћ: "c",
  џ: "dz",
  Ђ: "Dj",
  Ј: "j",
  Љ: "Lj",
  Њ: "Nj",
  Ћ: "C",
  Џ: "Dz",
  ǌ: "nj",
  ǉ: "lj",
  ǋ: "NJ",
  ǈ: "LJ",
  // hindi
  अ: "a",
  आ: "aa",
  ए: "e",
  ई: "ii",
  ऍ: "ei",
  ऎ: "ae",
  ऐ: "ai",
  इ: "i",
  ओ: "o",
  ऑ: "oi",
  ऒ: "oii",
  ऊ: "uu",
  औ: "ou",
  उ: "u",
  ब: "B",
  भ: "Bha",
  च: "Ca",
  छ: "Chha",
  ड: "Da",
  ढ: "Dha",
  फ: "Fa",
  ग: "Ga",
  घ: "Gha",
  ग़: "Ghi",
  ह: "Ha",
  ज: "Ja",
  झ: "Jha",
  क: "Ka",
  ख: "Kha",
  ख़: "Khi",
  ल: "L",
  ळ: "Li",
  ऌ: "Li",
  ऴ: "Lii",
  ॡ: "Lii",
  म: "Ma",
  न: "Na",
  ङ: "Na",
  ञ: "Nia",
  ण: "Nae",
  ऩ: "Ni",
  ॐ: "oms",
  प: "Pa",
  क़: "Qi",
  र: "Ra",
  ऋ: "Ri",
  ॠ: "Ri",
  ऱ: "Ri",
  स: "Sa",
  श: "Sha",
  ष: "Shha",
  ट: "Ta",
  त: "Ta",
  ठ: "Tha",
  द: "Tha",
  थ: "Tha",
  ध: "Thha",
  ड़: "ugDha",
  ढ़: "ugDhha",
  व: "Va",
  य: "Ya",
  य़: "Yi",
  ज़: "Za",
  // azerbaijani
  ə: "e",
  Ə: "E",
  // georgian
  ა: "a",
  ბ: "b",
  გ: "g",
  დ: "d",
  ე: "e",
  ვ: "v",
  ზ: "z",
  თ: "t",
  ი: "i",
  კ: "k",
  ლ: "l",
  მ: "m",
  ნ: "n",
  ო: "o",
  პ: "p",
  ჟ: "zh",
  რ: "r",
  ს: "s",
  ტ: "t",
  უ: "u",
  ფ: "p",
  ქ: "k",
  ღ: "gh",
  ყ: "q",
  შ: "sh",
  ჩ: "ch",
  ც: "ts",
  ძ: "dz",
  წ: "ts",
  ჭ: "ch",
  ხ: "kh",
  ჯ: "j",
  ჰ: "h",
  // hebrew
  ב: "v",
  גּ: "g",
  ג: "g",
  ד: "d",
  דּ: "d",
  ה: "h",
  ו: "v",
  ז: "z",
  ח: "h",
  ט: "t",
  י: "y",
  כ: "kh",
  ך: "kh",
  ל: "l",
  מ: "m",
  ם: "m",
  נ: "n",
  ן: "n",
  ס: "s",
  פ: "f",
  ף: "f",
  ץ: "ts",
  צ: "ts",
  ק: "k",
  ר: "r",
  תּ: "t",
  ת: "t"
};
m.charmap = Object.assign({}, D);
m.multicharmap = Object.assign({}, G);
m.defaults = {
  charmap: m.charmap,
  mode: "pretty",
  modes: {
    rfc3986: {
      replacement: "-",
      remove: null,
      lower: !0,
      charmap: m.charmap,
      multicharmap: m.multicharmap,
      trim: !0
    },
    pretty: {
      replacement: "-",
      remove: null,
      lower: !0,
      charmap: m.charmap,
      multicharmap: m.multicharmap,
      trim: !0
    }
  },
  multicharmap: m.multicharmap,
  fallback: !0
};
m.reset = function() {
  m.defaults.modes.rfc3986.charmap = m.defaults.modes.pretty.charmap = m.charmap = m.defaults.charmap = Object.assign({}, D), m.defaults.modes.rfc3986.multicharmap = m.defaults.modes.pretty.multicharmap = m.multicharmap = m.defaults.multicharmap = Object.assign({}, G), N = "";
};
m.extend = function(a) {
  const e = Object.keys(a), t = {}, r = {};
  for (let o = 0; o < e.length; o++)
    e[o].length > 1 ? t[e[o]] = a[e[o]] : r[e[o]] = a[e[o]];
  Object.assign(m.charmap, r), Object.assign(m.multicharmap, t);
};
m.setLocale = function(a) {
  N = R[a] || {};
};
const F = (a) => m(a, { lower: !1 }), B = /* @__PURE__ */ new Set(["so_com", "to_com"]), j = /* @__PURE__ */ new Set(["homecenter", "linio", "sodimac", "tottus"]), z = /* @__PURE__ */ new Set(["fa_aldo", "fa_america", "fa_carters", "fa_crabarr", "fa_thedrop"]), W = /* @__PURE__ */ new Set(["fa_aldo", "fa_america", "fa_carters", "fa_crabarr", "fa_thedrop"]), p = ({ store: a = "" }) => B.has(a), M = ({ store: a = "" }) => j.has(a), Y = ({ store: a = "" }) => z.has(a), ee = ({ store: a = "" }) => W.has(a), I = (a) => p({ store: a }) && a === "to_com", ae = (a) => p({ store: a }) && a === "so_com", te = (a) => a === "so_retail", h = {
  staging: "staging",
  uat: "beta",
  production: "www"
}, Q = {
  cl: {
    production: "10.6.0.76:8080",
    uat: "10.6.0.76:8080",
    staging: "10.6.0.22:8080"
  },
  co: {
    production: "10.6.0.81:8080",
    uat: "10.6.0.81:8080",
    staging: "10.6.0.22:8080"
  },
  pe: {
    production: "10.6.0.88:8080",
    uat: "10.6.0.88:8080",
    staging: "10.6.0.22:8080"
  },
  mx: {
    production: "",
    uat: "",
    staging: ""
  }
}, g = ({ regionCode: a, clSuffix: e = "cl" }) => a === "cl" ? e : `com.${a}`, $ = (a) => {
  const { environment: e = "production", regionCode: t, store: r, isWhiteLabelExperience: o = !1 } = a, c = r?.toLowerCase(), s = h[e] || h.production;
  let l = s, n = `${c}-${t}`, i = g({ regionCode: t, clSuffix: "com" }), u = "falabella";
  const d = { bigBrands: Y({ store: r }), sis: M({ store: r }) }, f = s === h.staging ? "staging-media" : "media";
  switch (c) {
    // STANDALONE
    case "so_com":
      i = g({ regionCode: t }), u = "sodimac", n = `sodimac-${t}`;
      break;
    case "to_com":
      i = g({ regionCode: t }), u = "tottus", n = `tottus-${t}`;
      break;
    // BIG BRANDS
    case "fa_aldo": {
      d.imgDomain = `https://${f}.falabella.${i}`, s === h.production || o ? (i = g({ regionCode: t }), u = t === "pe" ? "aldoshoes" : "aldo") : l = `${s}-aldo`, o ? n = t === "pe" ? `aldoshoes-${t}` : `aldo-${t}` : n = "", d.bigBrands = !0;
      break;
    }
    case "fa_carters": {
      d.imgDomain = `https://${f}.falabella.${i}`, s === h.production || o ? (i = g({ regionCode: t }), u = "carters") : l = `${s}-carters`, n = o ? `carters-${t}` : "", d.bigBrands = !0;
      break;
    }
    case "fa_crabarr": {
      d.imgDomain = `https://${f}.falabella.${i}`, s === h.production || o ? (i = g({ regionCode: t }), u = "crateandbarrel") : l = `${s}-crateandbarrel`, n = o ? `crateandbarrel-${t}` : "", d.bigBrands = !0;
      break;
    }
    case "fa_america": {
      d.imgDomain = `https://${f}.falabella.${i}`, s === h.production || o ? (u = "americanino", d.imgDelivery = `https://${u}.falabella.${i}`, i = g({ regionCode: t })) : l = `${s}-americanino`, n = o ? `americanino-${t}` : "", d.bigBrands = !0;
      break;
    }
    case "fa_thedrop": {
      d.imgDomain = `https://${f}.falabella.${i}`, s === h.production || o ? (u = "thedropzone", d.imgDelivery = `https://${u}.falabella.${i}`, i = g({ regionCode: t })) : l = `${s}-thedropzone`, n = o ? `thedropzone-${t}` : "", d.bigBrands = !0;
      break;
    }
    // STORE IN STORE
    case "sodimac":
      l = s === h.production ? c : `${s}-${c}`;
      break;
    case "homecenter":
      l = s === h.production ? c : `${s}-${c}`;
      break;
    case "tottus":
      l = s === h.production ? c : `${s}-${c}`;
      break;
    case "linio":
      l = s === h.production ? c : `${s}-${c}`;
      break;
    // MEXICO
    case "so_retail":
      i = g({ regionCode: t }), u = "sodimac", n = `sodimac-${t}`, d.imgDomain = `https://${f}.sodimac.cl`;
      break;
    default:
      n = `falabella-${t}`;
  }
  d.imgDomain || (d.imgDomain = `https://${f}.${u}.${i}`);
  const { href: _, origin: b, protocol: L, host: C, hostname: S, pathname: x } = new URL(
    `https://${l}.${u}.${i}/${n}`
  );
  return { href: _, origin: b, protocol: L, host: C, hostname: S, pathname: x, metadata: d };
}, oe = (a) => {
  const { environment: e = "production", store: t, context: r, regionCode: o, usePSCEndpoint: c = !1 } = a, s = t?.toLowerCase();
  let l = h[e] || h.production;
  l === h.uat && (l = h.production);
  let n, i = `${l}.`, u = "", d = "https";
  if (s === "to_com")
    if (l === h.staging)
      switch (n = "osmos.services", r) {
        case "catalog":
        case "prices":
        case "availability":
          i = "catalog-prod.";
          break;
        case "search":
          i = "search-prod.";
          break;
        default:
          i = "";
      }
    else
      i = "www.", n = "fazil.services";
  else if (s === "so_retail")
    n = "sodimac.services";
  else
    switch (n = "falabella.services", r) {
      case "search": {
        if (!o)
          throw new Error("regionCode is required to get proper DRB url for search context");
        u = l === h.staging ? "" : `/${o}`;
        const f = c ? Q[o][e] : "";
        f && (d = "http", i = "", n = f, u = "");
        break;
      }
    }
  return new URL(`${d}://${i}${n}${u}`);
}, re = (a) => {
  const { environment: e = "production", store: t, context: r } = a, o = h[e] || h.production, c = t?.toLowerCase();
  let s = o === h.staging ? "956098821484" : "1093673050246", l = "browse-api-credentials";
  if (c === "so_retail")
    return s = o === h.staging ? "273871379578" : "66566958714", l = "core-api-credentials", { id: s, name: l, path: `projects/${s}/secrets/${l}/versions/latest` };
  switch (r) {
    case "search":
    case "catalog":
    case "availability":
    case "prices":
      if (c === "to_com") {
        const n = o === h.staging;
        s = n ? "1038173027370" : "995770531595", l = n ? "fazil-api-credentials" : "fazil-commerce-marketplace-api-credentials";
      }
      break;
  }
  return { id: s, name: l, path: `projects/${s}/secrets/${l}/versions/latest` };
}, ce = (a) => {
  const { isMarketPlace: e, regionCode: t, store: r } = a;
  let o = "default", c = "marketplace.falabella.com", s = e ? "marketplace" : "falabella";
  switch (r?.toLowerCase()) {
    case "so_com":
      o = "sodimac", s += e ? "sodimac" : "", c = "marketplace.sodimac.falabella.com";
      break;
    case "so_retail":
      o = "sodimac", s = "sodimac", c = "SMXStore";
      break;
    case "to_com":
      o = "tottus", s += e ? "tottus" : "", c = "FAZIL_MKP";
      break;
    case "fa_america":
      o = "americanino", s = "americanino", c = "marketplace.americanino.falabella.com";
      break;
    case "fa_aldo":
      o = "aldo", s = "aldo", c = "marketplace.aldo.falabella.com";
      break;
    case "fa_carters":
      o = "carters", s = "carters", c = "marketplace.carters.falabella.com";
      break;
    case "fa_crabarr":
      o = "crateandbarrel", s = "crateandbarrel", c = "marketplace.crateandbarrel.falabella.com";
      break;
    case "fa_thedrop":
      o = "thedropzone", s = "thedropzone", c = "marketplace.thedropzone.falabella.com";
      break;
  }
  return {
    "x-ecomm-name": `${s}-${t}`,
    "x-site-name": o,
    "x-site-id": c
  };
}, se = (a) => {
  const { environment: e = "production", regionCode: t, store: r, isWhiteLabelExperience: o = !1 } = a, c = M({ store: r }) ? "falabella" : r, { href: s, origin: l, metadata: n } = $({ store: c, regionCode: t, environment: e, isWhiteLabelExperience: o });
  return n.bigBrands && !o ? new URL(`${l}/cart`) : new URL(`${s}/basket`);
}, ne = (a) => {
  const { environment: e = "production", regionCode: t, store: r, isWhiteLabelExperience: o = !1 } = a, { href: c } = $({ store: r, regionCode: t, environment: e, isWhiteLabelExperience: o });
  return p({ store: r }) ? new URL(`${c}/vendedor`) : new URL(`${c}/seller`);
}, ie = (a) => {
  const { environment: e = "production", regionCode: t, store: r, isWhiteLabelExperience: o = !1 } = a, { href: c } = $({ store: r, regionCode: t, environment: e, isWhiteLabelExperience: o });
  return p({ store: r }) ? new URL(`${c}/marca`) : new URL(`${c}/brand`);
}, le = (a) => {
  const { environment: e = "production", regionCode: t, store: r, isWhiteLabelExperience: o = !1 } = a, { href: c } = $({ store: r, regionCode: t, environment: e, isWhiteLabelExperience: o });
  return p({ store: r }) ? new URL(`${c}/seleccion`) : new URL(`${c}/collection`);
}, me = (a) => {
  const { environment: e = "production", regionCode: t, store: r, isWhiteLabelExperience: o = !1 } = a, { href: c } = $({ store: r, regionCode: t, environment: e, isWhiteLabelExperience: o });
  return p({ store: r }) ? new URL(`${c}/lista`) : new URL(`${c}/category`);
}, de = (a) => {
  const { environment: e = "production", regionCode: t, store: r, isWhiteLabelExperience: o = !1 } = a, { href: c } = $({ store: r, regionCode: t, environment: e, isWhiteLabelExperience: o });
  return p({ store: r }) ? new URL(`${c}/buscar`) : new URL(`${c}/search`);
}, ue = (a) => {
  const {
    environment: e = "production",
    regionCode: t,
    store: r,
    productId: o,
    productName: c,
    productSlug: s,
    skuId: l,
    withExp: n = !0,
    isWhiteLabelExperience: i = !1,
    sellerId: u
  } = a, { href: d, origin: f, pathname: _, metadata: b } = $({
    store: r === "linio" ? "" : r,
    regionCode: t,
    environment: e,
    isWhiteLabelExperience: i
  }), L = l ? `/${l}` : "";
  let C = d, S = "product";
  const x = p({ store: r });
  x ? S = "articulo" : b.bigBrands && (S = i ? "product" : "products", C = i ? `${f}${_}` : f);
  let w;
  if (s) {
    const T = encodeURI(s);
    w = new URL(`${C}/${S}/${o}/${T}${L}`);
  } else {
    const T = F(c);
    w = new URL(`${C}/${S}/${o}/${T}${L}`);
  }
  return n && (x && !I(r) || b.sis) && w.searchParams.set("exp", r), u && !I(r) && w.searchParams.set("sellerId", u), w;
}, he = (a) => {
  const { store: e, metadata: t } = a;
  switch (e.toLowerCase()) {
    case "linio":
    case "tottus":
    case "sodimac":
    case "homecenter":
    case "fa_carters":
    case "fa_aldo":
    case "fa_crabarr":
    case "fa_america":
    case "fa_thedrop":
      return {
        site: e.toUpperCase()
      };
    case "so_com":
      return t?.isSearchWithSoCom === !0 ? { site: "SO_COM" } : { site: "SODIMAC" };
    case "to_com":
      return {};
    case "so_retail":
      return {};
    default:
      return { site: "FA_MKP" };
  }
}, v = {
  so_com: {
    title: "Sodimac",
    og: {
      siteName: {
        cl: "Sodimac",
        co: "",
        pe: "SodimacPE",
        mx: "SodimacMX"
      },
      title: {
        cl: "sodimac.cl",
        co: "",
        pe: "sodimac.com.pe",
        mx: "sodimac.com.mx"
      },
      image: "https://images.contentstack.io/v3/assets/blt34d59f5b52e53f95/blt06c32fd8854081c8/og-image.jpeg",
      searchPage: "/sodimac-{region}/buscar/"
    }
  },
  to_com: {
    title: "Tottus",
    og: {
      siteName: {
        cl: "Tottus",
        co: "",
        pe: "TottusPE",
        mx: ""
      },
      title: {
        cl: "tottus.cl",
        co: "",
        pe: "tottus.com.pe",
        mx: ""
      },
      image: "https://images.falabella.com/v3/assets/blt72431f7a08fe765a/blt90316d53057fbea5/cuadro-logo-tottus.png",
      searchPage: "/tottus-{region}/buscar/"
    }
  },
  fa_america: {
    title: "Americanino",
    og: {
      siteName: {
        cl: "Americanino Chile",
        co: "",
        pe: "",
        mx: ""
      },
      title: {
        cl: "americanino.cl",
        co: "",
        pe: "",
        mx: ""
      },
      image: "https://images.falabella.com/v3/assets/bltb9d14061af10d563/bltffb7e744c6ef54a4/679866f82408e463e0d5e38b/logo.svg",
      searchPage: "/americanino-{region}/search/"
    }
  },
  fa_carters: {
    title: "Carters",
    og: {
      siteName: {
        cl: "Carters Chile",
        co: "",
        pe: "Carters Perú",
        mx: ""
      },
      title: {
        cl: "carters.cl",
        co: "",
        pe: "carters.com.pe",
        mx: ""
      },
      image: "https://images.falabella.com/v3/assets/bltb9d14061af10d563/blte519222fb2afb54e/679c7958e729222d0f536c25/carterslogo.svg",
      searchPage: "/carters-{region}/search/"
    }
  },
  fa_aldo: {
    title: "Aldo",
    og: {
      siteName: {
        cl: "Aldo Chile",
        co: "",
        pe: "Aldo Shoes Peru",
        mx: ""
      },
      title: {
        cl: "aldo.cl",
        co: "",
        pe: "aldoshoes.com.pe",
        mx: ""
      },
      image: "https://images-uat.falabella.com/v3/assets/bltb9d14061af10d563/blt8f8c3b67ee612d73/67b2cc30d5c33d221df0d3d3/aldo-logo.svg",
      searchPage: "/aldo-{region}/search/"
    }
  },
  fa_crabarr: {
    title: "Crate and Barrel",
    og: {
      siteName: {
        cl: "Crate and Barrel Chile",
        co: "Crate & Barrel Colombia",
        pe: "Crate & Barrel Perú",
        mx: ""
      },
      title: {
        cl: "crateandbarrel.cl",
        co: "crateandbarrel.com.co",
        pe: "crateandbarrel.com.pe",
        mx: ""
      },
      image: "https://images.falabella.com/v3/assets/bltb9d14061af10d563/blt2293b0260edd5250/67b851386ee1938218933687/crabarr-logo.svg",
      searchPage: "/crateandbarrel-{region}/search/"
    }
  },
  fa_thedrop: {
    title: "The Drop Zone",
    og: {
      siteName: {
        cl: "The Drop Zone Chile",
        co: "The Drop Zone Colombia",
        pe: "The Drop Zone Perú",
        mx: ""
      },
      title: {
        cl: "thedropzone.cl",
        co: "thedropzone.com.co",
        pe: "thedropzone.com.pe",
        mx: ""
      },
      image: "https://images.falabella.com/v3/assets/bltb9d14061af10d563/blt2293b0260edd5250/67b851386ee1938218933687/crabarr-logo.svg",
      // pending to get logo svg for drop zone
      searchPage: "/thedropzone-{region}/search/"
    }
  },
  default: {
    title: "Falabella.com",
    og: {
      siteName: {
        cl: "Falabella",
        co: "FalabellaCO",
        pe: "FalabellaPE",
        mx: ""
      },
      title: {
        cl: "falabella.com",
        co: "falabella.com",
        pe: "falabella.com",
        mx: ""
      },
      image: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt82dfb1aadb87635c/OG_Fcom.jpg",
      searchPage: "/falabella-{region}/search/"
    }
  }
}, k = (a) => v[a?.toLowerCase()] || v.default, fe = (a) => {
  const { store: e = "" } = a, { title: t } = k(e);
  return t;
}, ge = (a) => {
  const { store: e = "" } = a, { og: t } = k(e);
  return t.image;
}, pe = (a) => {
  const { regionCode: e, store: t = "" } = a, { og: r } = k(t);
  return r.siteName[e];
}, be = (a) => {
  const { regionCode: e, store: t = "" } = a, { og: r } = k(t);
  return r.title[e];
}, $e = (a) => {
  const { regionCode: e, store: t = "" } = a, { og: r } = k(t);
  return r.searchPage.replace("{region}", e);
}, y = "x-cartline-quantities", J = /^(\S+:\S+:\d+:(undefined|\d*\.?\d+))(,\S+:\S+:\d+:(undefined|\d*\.?\d+))?$/, _e = (a) => a?.cartLines?.map((e) => `${e.offeringId}:${e.cartLineId}:${e.quantity.quantityNumber}:${e.qtyLimits}`).join(",") || "", K = (a = "") => {
  const e = /* @__PURE__ */ new Map();
  return J.test(a) && (a?.split(",")).forEach((r) => {
    const [o, c, s, l] = r.split(":"), n = Number(l);
    e.set(o, {
      cartLineId: c,
      quantity: parseInt(s, 10),
      quantityLimit: isNaN(n) ? void 0 : n
    });
  }), e;
}, Se = (a) => {
  const { headers: e = new Headers() } = a, t = e?.get(y) ?? "", r = K(t), o = Object.fromEntries(r);
  localStorage.setItem(y, JSON.stringify(o));
}, Ce = () => {
  try {
    const a = localStorage.getItem(y) ?? "{}", e = JSON.parse(a);
    return new Map(Object.entries(e));
  } catch {
    return /* @__PURE__ */ new Map();
  }
}, Z = (a) => {
  if (a.length === 0) return "";
  const e = a.toLowerCase();
  return e.substring(0, 1).toUpperCase() + e.substring(1, e.length);
}, q = (a, e) => Number.isInteger(a) ? a : a.toFixed(e), we = ({ maxUnits: a, minSaleQty: e, unit: t }) => {
  if (a)
    return `Máximo ${q((e || 1) * a, 1)} ${Z(t || "Un")}.`;
};
export {
  J as CART_LINE_QUANTITIES_REGEX,
  y as QTY_LIMITS_KEY,
  _e as encodeCartQuantities,
  ce as getCommerceHeaders,
  V as getCookieDomain,
  re as getDRBTokenInfo,
  oe as getDRBUrl,
  H as getGTMKey,
  X as getLatLongFromAddressLine,
  we as getMaxQuantityString,
  ge as getOGImageURL,
  $e as getOGSearchUrl,
  pe as getOGSiteName,
  be as getOGTitleName,
  Ce as getQuantityMapFromStorage,
  he as getQueryParamsForSearch,
  fe as getSeoPageTitle,
  se as getUrlForBasket,
  ie as getUrlForBrand,
  me as getUrlForCategory,
  le as getUrlForCollection,
  ue as getUrlForProduct,
  de as getUrlForSearch,
  ne as getUrlForSeller,
  $ as getUrlParts,
  Y as isBigBrand,
  te as isSodimacRetail,
  ae as isSodimacStandalone,
  p as isStandalone,
  M as isStoreInStore,
  I as isTottusStandalone,
  ee as isWhitelabel,
  K as parseCartQuantities,
  Se as updateCartQtyLimits
};
